<template>
  <div class="all">
    <div class="menue">
      <span class="text">请选择投诉建议</span>
      <div class="xx">
        <ul>
          <template v-for="(item, index) in this.$store.state.codelist['MSG_SUGGESTION']">
            <li class="aa red" :key="index">
              {{ item }}
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="context">
      <span class="text">详细描述</span>
      <textarea
        placeholder="请提供更详细的信息，以便更好地解决您得问题"
        class="message"
        v-model="formData.content"
      ></textarea>
      <van-uploader
        :before-read="beforeRead" 
        :after-read="afterRead" />
    </div>
    <div class="submit"><span @click="submitSuggestion()">立即提交</span></div>
  </div>
</template>

<script>
import * as imageConversion from 'image-conversion'
export default {
  name: 'tousuyijiansub',
  data() {
    return {
      formData: {
        category: 'service',
        content: '',
        gallery: [],
      },
    }
  },
  created() {},
  mounted() {},
  methods: {
    submitSuggestion() {
      this.$submit('/api/msgsuggestion/addSuggestion', this.formData, function(res) {
        if (res['code'] === 1) {
          alert('成功')
        }
      })
    },
    async beforeRead(file){
      const MAX_SIZE = 300
      if(file.size > (MAX_SIZE+20)*1024){
        return new Promise((resolve, reject) =>{
          imageConversion.compressAccurately(file, MAX_SIZE).then((res) => {
            res = new File([res], file.name);
            resolve(res);
          });
          console.log(reject)
        })
      } else {
        return file
      }
    },
    afterRead(file) {
      var that = this
      this.$upload('MsgSuggestion', file, { field: 'gallery' }, function(res) {
        console.log(JSON.stringify(res))
        that.formData.gallery.push(res['data']['url'])
      })
    },
  },
}
</script>

<style>
.all {
  overflow: hidden;
}
.menue {
  background-color: #fff;
  margin: 1rem;
  padding-bottom: 1rem;
}
.text {
  position: relative;
  top: 1.7rem;
  left: 1.5rem;
  font-size: 1.6rem;
}
.menue .xx {
  margin-top: 1.9rem;
  margin-left: 1.3rem;
}
.menue .xx ul {
  overflow: auto;
  margin-bottom: 1.5rem;
}
.menue .xx ul li {
  width: 46%;
  height: 3.2rem;
  border: 0.1rem solid #eee;
  margin-top: 1rem;
  text-align: center;
  padding-top: 0.6rem;
  float: left;
  margin-right: 1rem;
  font-size: 1.4rem;
}
.aa {
  background-color: #fff;
}
.context {
  background-color: #fff;
  margin: 1rem 1rem 0;
  padding-bottom: 1rem;
}
.text {
  position: relative;
  top: 1.7rem;
  left: 1.5rem;
  font-size: 1.6rem;
}
.context .message {
  width: 91%;
  height: 9rem;
  border: 0.1rem solid #eee;
  margin-left: 1.5rem;
  margin-top: 3.6rem;
  font-size: 1.4rem;
  color: #999;
  padding: 1rem 0.5rem 0 1rem;
}
.submit {
  height: 3.9rem;
  background-color: #15a892;
  text-align: center;
  margin-top: 14.6rem;
  padding-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  border: 0.1rem solid #eee;
  box-sizing: border-box;
}

.submit span {
  color: #fff;
  text-align: center;
  font-size: 14px;
}

.red {
  background-color: #15a892;
  color: #fff;
}
</style>
